import styled from 'styled-components';
import { getWeeklyDateForOrganization, isWeeklySongListForDate } from '../../../../common/src/org.ts';
import { LocalStorageKey } from '../../data/client_local_storage.ts';
import { useCurrentOrg } from '../../data/use_current_org.tsx';
import { useLocalStorage } from '../../data/use_local_storage.tsx';
import { useCurrentDate } from '../../util/use_current_date.tsx';
import { OrgPage } from '../org_page.tsx';
import { Tile } from './shared.tsx';

export const ThisSundayTile = () => {
  const { currentOrg } = useCurrentOrg();
  const [songsForWeek] = useLocalStorage(LocalStorageKey.WeeklySongList);
  const today = useCurrentDate();

  const weeklySongListEmpty =
    songsForWeek?.find((songList) =>
      isWeeklySongListForDate(currentOrg, songList, getWeeklyDateForOrganization(currentOrg, today)),
    ) === undefined;

  return (
    <Tile $thinTopPadding={true} $hidden={weeklySongListEmpty}>
      <PageWrapper>
        <OrgPage showThisSundayOnly={true} />
      </PageWrapper>
    </Tile>
  );
};

const PageWrapper = styled.div`
  padding-bottom: 15px;
`;
